import { FeatureFlag, DbRef } from '@caresend/types';
import '@caresend/utils';
import 'firebase/auth';
import '../../database/firebaseConfig/cloudFunctions.js';
import '../../database/firebaseConfig/init.js';
import { dbSet } from '../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../components/ui/Icon.vue.js';
import '../configuration/icons.js';
import '../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../tracking/index.js';
import '../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'js-sha256';
import '../../components/specific/portal/store/portal/index.js';
import '../../store/modules/app/model.js';
import './scanning.js';
import '../../store/modules/procedures/model.js';

// SUPPLY ITEM
/**
 * Updates status of a supply item, unless the supply item ID is
 * `disablePatientVisitSupplyScanning`.
 */
const updateSupplyItemStatus = async (supplyItemID, status) => {
    // When scanning is disabled via feature flag, the feature flag name is
    // used in place of the supplyItemID. Do not attempt to update the supply
    // item status in this case.
    if (supplyItemID !== FeatureFlag.DISABLE_PATIENT_VISIT_SUPPLY_SCANNING) {
        await dbSet(`${DbRef.SUPPLY_ITEMS}/${supplyItemID}/status`, status);
    }
};

export { updateSupplyItemStatus };
